import { apiClient } from "./client";

export type PublicLegalTerm = {
  category: string;
  content: string;
  created_at?: string | null;
  id: string;
  is_active: boolean;
  title: string;
  updated_at?: string | null;
  version?: string | null;
};

export const publicLegalTermsQueryKey = ["public-legal-terms"] as const;
export const publicLegalTermsStaleTime = 30 * 60_000;

export async function getPublicLegalTerms(category?: string): Promise<PublicLegalTerm[]> {
  const { data } = await apiClient.get<PublicLegalTerm[]>("/legal/terms", {
    params: category ? { category } : undefined,
  });

  return Array.isArray(data) ? data : [];
}
